import { sendTracking } from "./infoModalsDataLayer";

const modalSelector = ".info-modal";
const triggerClass = "js-info-modal-trigger";
const closeButtonSelector = ".js-close-info-modal";
const openClass = "is-visible";

const showModal = (modal) => {
	modal.classList.add(openClass);
};

const hideModal = (modal) => {
	modal.classList.remove(openClass);
	modal.dispatchEvent(new Event("hideModal"));
};

const init = () => {
	const modals = document.querySelectorAll(modalSelector);
	[...modals].forEach((modal) => {
		const triggers = [modal.previousElementSibling].filter((el) => el.classList.contains(triggerClass));
		const closeButtons = [...modal.querySelectorAll(closeButtonSelector)];
		const trackCategory = modal.dataset.trackCategory;

		document.body.appendChild(modal);

		const _showModal = (event) => {
			showModal(modal);
			// tracking
			const trackAction = event.currentTarget?.dataset.trackAction || `${trackCategory}Shown`;
			sendTracking(trackCategory, trackAction);
		};
		const _hideModal = (event) => {
			hideModal(modal);
			// tracking
			const trackAction = event.currentTarget?.dataset.trackAction || `${trackCategory}Closed`;
			sendTracking(trackCategory, trackAction);
		};

		// initial tracking
		if (modal.classList.contains(openClass)) sendTracking(trackCategory, `${trackCategory}Shown`);

		triggers.forEach((el) => el.addEventListener("click", _showModal));
		closeButtons.forEach((el) => el.addEventListener("click", _hideModal));
		modal.addEventListener("click", (e) => e.target === modal && _hideModal(e));
	});
};

export { init, showModal, hideModal };
